import PopBalloonPage from "./PopBalloon";

const Index = () => {
  return <PopBalloonPage />;
};

export default Index;
